import React, { useEffect, useRef, useState } from "react";
import { APP_VERSION } from "../../version";
import "../../style.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { login, register } from "../../redux/actions/userAction";
import axios from "axios";

import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { makeStyles, withStyles } from "@material-ui/styles";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { toast } from "react-toastify";
import { api } from "../../mockData";
import { Box, IconButton, InputAdornment } from "@mui/material";

const CssTextField = withStyles({
  root: {
    "& label": {
      color: "white",
    },
    "& label.Mui-focused": {
      color: "white",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "white",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "white",
      },
      "&:hover fieldset": {
        borderColor: "white",
      },
      "&.Mui-focused fieldset": {
        borderColor: "white",
      },
    },
  },
  input: {
    color: "white", // Set default text color to white
    backgroundColor: "rgb(232, 241, 250)", // Set default background color
  },
})(TextField);

function Login() {
  const current_user = localStorage.getItem("current_user");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword(!showPassword);

  const handleMouseDownPassword = (event) => event.preventDefault();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const buttonRef = useRef(null);
  const location = useLocation();
  const redirect = location?.state?.data;

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = JSON.stringify({ username: email, password: password });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${api.dev}/api/login`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        const values = response?.data;
        if (values?.status === 200) {
          if (values.user_role === "Superadmin") {
            // localStorage.setItem("current_superadmin", values.user_name);
            // localStorage.setItem(`superadmin_${values.user_name}`, JSON.stringify(values));
            localStorage.setItem("admin", JSON.stringify(values));
            navigate("/admin_portal", { state: { data: data } });
          } else if (values.user_role === "Admin") {
            localStorage.setItem("admin", JSON.stringify(values));
            navigate("/admin_portal");
          } else if (values.user_role === "Reseller") {
            localStorage.setItem("admin", JSON.stringify(values));
            localStorage.setItem("reseller", JSON.stringify(values));
            navigate("/reseller_portal");
          } else if (values.user_role !== "Superadmin" && values.user_role !== "Admin" && values.user_role !== "Reseller") {
            localStorage.setItem("current_user", values.user_name);
            localStorage.setItem(
              `user_${values.user_name}`,
              JSON.stringify(values)
            );
            navigate("/redirect_portal");
          }
          // Clear the form fields
          setEmail("");
          setPassword("");

          dispatch(login(values));
        }
        if (values.status === 200) {
          toast.success(values.message, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1500,
          });
          //   navigate("/"})
        } else {
          toast.error(values.message, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
          });
        }
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 6000,
        });
      });
  };

  const handleFocus = (e) => {
    e.target.select();
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      buttonRef.current.click();
    }
  };


   

  const handleRefresh = () => {
    // Full page reload
    window.location.reload();
  };

  const plexusNodes = [
    { top: "6%",  left: "8%",  delay: "0.0s" },
    { top: "8%",  left: "22%", delay: "0.7s" },
    { top: "5%",  left: "38%", delay: "1.4s" },
    { top: "10%", left: "54%", delay: "2.1s" },
    { top: "7%",  left: "70%", delay: "2.8s" },
    { top: "9%",  left: "86%", delay: "3.5s" },
    { top: "22%", left: "14%", delay: "0.3s" },
    { top: "20%", left: "32%", delay: "1.0s" },
    { top: "24%", left: "48%", delay: "1.7s" },
    { top: "21%", left: "64%", delay: "2.4s" },
    { top: "23%", left: "80%", delay: "3.1s" },
    { top: "25%", left: "94%", delay: "0.5s" },
    { top: "38%", left: "6%",  delay: "1.2s" },
    { top: "40%", left: "20%", delay: "1.9s" },
    { top: "36%", left: "90%", delay: "2.6s" },
    { top: "42%", left: "96%", delay: "3.3s" },
    { top: "55%", left: "10%", delay: "0.4s" },
    { top: "54%", left: "26%", delay: "1.1s" },
    { top: "58%", left: "88%", delay: "1.8s" },
    { top: "56%", left: "94%", delay: "2.5s" },
    { top: "70%", left: "4%",  delay: "0.1s" },
    { top: "72%", left: "18%", delay: "0.8s" },
    { top: "68%", left: "34%", delay: "1.5s" },
    { top: "74%", left: "50%", delay: "2.2s" },
    { top: "70%", left: "66%", delay: "2.9s" },
    { top: "72%", left: "82%", delay: "3.6s" },
    { top: "76%", left: "96%", delay: "0.6s" },
    { top: "88%", left: "12%", delay: "1.3s" },
    { top: "86%", left: "28%", delay: "2.0s" },
    { top: "90%", left: "44%", delay: "2.7s" },
    { top: "85%", left: "60%", delay: "3.4s" },
    { top: "92%", left: "76%", delay: "0.2s" },
    { top: "88%", left: "92%", delay: "0.9s" },
    { top: "15%", left: "62%", delay: "1.6s" },
    { top: "30%", left: "8%",  delay: "2.3s" },
    { top: "48%", left: "40%", delay: "3.0s" },
    { top: "60%", left: "72%", delay: "3.7s" },
    { top: "80%", left: "38%", delay: "0.4s" },
  ];

  return (
    <section className="login-sec">
      <div className="plexus-overlay" aria-hidden="true">
        {plexusNodes.map((n, i) => (
          <span
            key={i}
            style={{ top: n.top, left: n.left, animationDelay: n.delay }}
          />
        ))}
      </div>
      <div className="container">
        <div className="row d-flex justify-content-center align-items-cente m-auto">
          <div className="col-xl-5 col-lg-6 col-md-8 col-12 d-flex justify-content-center align-items-center">
            <div className="login-logo">
              <Card className="login-box" sx={{}}>
                <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
                  <Box
                    component="form"
                    className="login_form"
                    onKeyDown={handleKeyPress}
                    sx={{
                      display: "grid",
                      gridTemplateColumns: { xs: "1fr", md: "1fr 40%" },
                      gridTemplateAreas: {
                        xs: `"logo" "username" "password" "forgot" "button"`,
                        md: `"username logo" "password button" "forgot ."`,
                      },
                      columnGap: { xs: 0, md: 2.5 },
                      rowGap: { xs: 1, md: 1 },
                      alignItems: "stretch",
                    }}
                  >
                    <Box
                      sx={{
                        gridArea: "logo",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        pt: { xs: 0, md: "23px" },
                      }}
                    >
                      <span className="tellipsis-logo-wrap">
                        <img
                          src={`../img/logo_white11.png`}
                          className="login-logo-img img-fluid d-block"
                          alt={"login logo"}
                        />
                        <span className="tellipsis-version-badge">{APP_VERSION}</span>
                      </span>
                    </Box>

                    <Box sx={{ gridArea: "username" }}>
                      <label
                        htmlFor="username-input"
                        style={{
                          color: "#fff",
                          textAlign: "left",
                          display: "block",
                          paddingBottom: "3px",
                        }}
                      >
                        Username
                      </label>
                      <TextField
                        id="username-input"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        variant="outlined"
                        autoComplete="email"
                        type="text"
                        fullWidth
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "10px",
                            transition: "box-shadow 0.2s ease",
                            "& fieldset": {
                              borderColor: "rgba(255,255,255,0.35)",
                            },
                            "&:hover fieldset": {
                              borderColor: "rgba(255,255,255,0.6)",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#fff",
                            },
                            "&.Mui-focused": {
                              boxShadow: "0 0 0 3px rgba(255,255,255,0.12)",
                            },
                            "& input::placeholder": {
                              color: "rgba(255,255,255,0.55)",
                              opacity: 1,
                            },
                          },
                          input: { color: "white" },
                        }}
                      />
                    </Box>

                    <Box sx={{ gridArea: "password" }}>
                      <label
                        htmlFor="password-input"
                        style={{
                          color: "#fff",
                          textAlign: "left",
                          display: "block",
                          paddingBottom: "3px",
                        }}
                      >
                        Password
                      </label>
                      <TextField
                        id="password-input"
                        name="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        variant="outlined"
                        autoComplete="current-password"
                        type={showPassword ? "text" : "password"}
                        fullWidth
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={handleClickShowPassword}
                                onMouseDown={(e) => e.preventDefault()}
                                edge="end"
                                style={{ color: "#fff" }}
                              >
                                {showPassword ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "10px",
                            transition: "box-shadow 0.2s ease",
                            "& fieldset": {
                              borderColor: "rgba(255,255,255,0.35)",
                            },
                            "&:hover fieldset": {
                              borderColor: "rgba(255,255,255,0.6)",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#fff",
                            },
                            "&.Mui-focused": {
                              boxShadow: "0 0 0 3px rgba(255,255,255,0.12)",
                            },
                            "& input::placeholder": {
                              color: "rgba(255,255,255,0.55)",
                              opacity: 1,
                            },
                          },
                          input: { color: "white" },
                        }}
                      />
                    </Box>

                    <Box sx={{ gridArea: "forgot" }}>
                      <Typography
                        variant="body2"
                        className="text-end login-inpt-txt"
                      >
                        <p
                          style={{ cursor: "pointer", color: "#fff", margin: 0 }}
                          onClick={() => {
                            navigate("/send_email");
                          }}
                        >
                          Forgot your password?
                        </p>
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        gridArea: "button",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        pt: { xs: 0, md: "32px" },
                      }}
                    >
                      <Button
                        type="submit"
                        className="login_button"
                        onClick={handleSubmit}
                        ref={buttonRef}
                      >
                        Login
                      </Button>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </div>
          </div>



          <Box className="refresh_btn pt-3 d-lg-none d-md-none  d-sm-block d-xs-block" style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              type="submit"
              // ref={buttonRef}
              onClick={handleRefresh}
              variant="contained"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",

                backgroundColor: "#fda90d",
                color: "#fff",

                fontSize: "14px",
                fontWeight: 500,
                textTransform: "capitalize",
                height: "35px",
                px: 2,
                borderRadius: "6px",

                boxShadow: "none",

                "&:hover": {
                  backgroundColor: "#0b5ed7",
                  boxShadow: "none",
                },

                "&:active": {
                  transform: "scale(0.97)",
                },

                "&.Mui-disabled": {
                  backgroundColor: "#b0b0b0",
                  color: "#fff",
                },
              }}
            >
              Refresh
            </Button>
          </Box>

        </div>
      </div>
    </section>
  );
}

export default Login;
